import ApiService from "./api.service";

const TenantService = {
  async publicTenantLanguages(baseURL, tenantId) {
    try {
      return await ApiService.get("public/tenant-languages", {
        baseURL,
        headers: {
          Accept: "application/json",
          "X-Tenant": tenantId,
        },
      });
    } catch (error) {
      return error.response || null;
    }
  },
};

export default TenantService;
